export default "__VITE_ASSET__CQZwAd4X__"